import { z } from "zod";
import { sortingSchema } from '~/.server/api/routers/workspace';
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from "~/components/ui/select";

export type SortBy = z.infer<typeof sortingSchema>['sortBy'];
export type SortOrder = z.infer<typeof sortingSchema>['sortOrder'];
export type SortValue = `${SortBy}-${SortOrder}`;

export type SortProps = {
  value: SortValue;
  onValueChange: (value: SortValue) => void;
}

const sortOptions: Array<{ label: string; value: SortValue }> = [
  { label: "Más recientes", value: "createdAt-desc" },
  { label: "Más antiguos", value: "createdAt-asc" },
  { label: "Precio menor", value: "priceMin-asc" },
  { label: "Precio mayor", value: "priceMin-desc" }
];

export function SortSelect({ value, onValueChange }: SortProps) { 
  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger className="w-[180px]">
        <SelectValue placeholder="Ordenar por" />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          {sortOptions.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
